export { default } from "./FullScreen.vue";
